// src/trackingScripts.ts

// JSONファイルの型定義をここにも記述しておくと便利です
interface SnippetData {
  title: string;
  description: string;
  code?: string;
  url?: string;
}

interface ScriptData {
  [platform: string]: {
    [key: string]: SnippetData;
  };
}

const successfeeUrl = import.meta.env.VITE_SUCCESSFEE_ENDPOINT;
const customAppUrl = import.meta.env.VITE_CUSTOM_APP_ENDPOINT;

// データ本体
// TODO: バージョン名追加
export const scriptData: ScriptData = {
  shopify: {
    visit: {
      title: '訪問計測用スクリプト(visit_store)',
      description:
        'Shopify管理画面の「設定 > 顧客イベント > カスタムピクセルを追加」を選択してピクセル名に「visit_store」を記入し、コード欄に以下貼り付けてください。',
      code: `// Ver 1.0.0
function getValueFromStorage(key) {
  const valueFromCookie = getCookieValue(key);
  if (valueFromCookie) {
    return valueFromCookie;
  }
  return localStorage.getItem(key);
}

function setValueToStorage(key, value, expirationDays) {
  localStorage.setItem(key, value);
  overwriteCookie(key, value, expirationDays);
}


function getCookieValue(cookieName) { 
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookie = cookieArray[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length);
        }
    }
    return null;
}

function overwriteCookie(cookieName, cookieValue, expirationDays) {
    var d = new Date();
    d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/;SameSite=Lax";
}

function getAffiliateIDFromURL() {
    var urlParams = new URLSearchParams(window.location.search);
    var affiId_url = urlParams.get('affi_id');
    return affiId_url ? affiId_url : null;
}

var affiId = getValueFromStorage("affi_id");
var fuId = getValueFromStorage("fu_id");
var affiId_url = getAffiliateIDFromURL();

if (affiId_url !== null) {
    setValueToStorage("affi_id", affiId_url, 90);
    affiId = affiId_url;
}

if (affiId !== null) {
    analytics.subscribe("page_viewed", (event) => {
        document.cookie = 'name="_tracking_consent=; max-age=0';
        console.log('custom event', event);
        const data = {
            affi_id: affiId,
        };

        if (fuId !== null) {
            data.fu_id = fuId;
        }

        console.log('Sending data:', data);

        fetch("${successfeeUrl}/shopify/visit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            console.log('Response data:', data);
            const fuidFromResponse = data.fu_id;
            if (fuidFromResponse && fuId === null) {
                setValueToStorage("fu_id", fuidFromResponse, 90);
            }
        })
    });
}
`
    },
    checkout_started: {
      title: 'チェックアウト開始計測用スクリプト(checkout_started)',
      description:
        'Shopify管理画面の「設定 > 顧客イベント > カスタムピクセルを追加」を選択してピクセル名に「checkout_started」を記入し、コード欄に以下貼り付けてください。',
      code: `// Ver 1.0.0
function getCookieValue(cookieName) {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');

    for (var i = 0; i < cookieArray.length; i++) {
        var cookie = cookieArray[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length);
        }
    }
    return null;
}

var affiId = getCookieValue("affi_id");
var fuId = getCookieValue("fu_id");

analytics.subscribe("checkout_started", async (event) => {
    console.log('Checkout Started Event:', event);
    document.cookie = 'name="_tracking_consent=; max-age=0';

    const items = event.data?.checkout?.lineItems?.map(discount => {
        return {
            quantity: discount.quantity,
            title: discount.title
        };
    });
    const storeDomain = event.context?.document?.location?.origin;
    const storeId = __CLIENT_ID__;
    const checkToken = event.data?.checkout?.token;
    const data = {
        store_id: storeId,
        checkout_token: checkToken,
    };
    if (storeDomain) {
        data.storeDomain = storeDomain;
    }
    if (affiId) {
        data.affi_id = affiId;
    }
    if (fuId) {
        data.fu_id = fuId;
    }
    console.log('Sending Data:', data);
    fetch("${customAppUrl}/shopify/order", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    })
    .then(response => response.text())
    .then(() => {
        console.log("POST OK");
    })
    .catch(error => {
        console.error("POSTエラー:", error);
    });
});
`
    },
    payment_webhook: {
      title: '購入完了用 Webhook URL',
      description:
        'Shopify管理画面の「設定 > 通知 > Webhook」で「注文の決済」イベントに以下のURLを設定してください。',
      url: `${customAppUrl}/shopify/payment`
    },
    cancel_webhook: {
      title: 'キャンセル用 Webhook URL',
      description:
        'Shopify管理画面の「設定 > 通知 > Webhook」で「注文のキャンセル」イベントに以下のURLを設定してください。',
      url: `${customAppUrl}/shopify/cancel`
    },
    scope_text: {
      title: 'スコープ用 テキスト',
      description:
        'Dev Dashboard画面の「アプリ>アプリを作成する」で「アクセスのスコープ」に以下のテキストを設定してください。',
      code: 'read_analytics,read_app_proxy,write_app_proxy,read_assigned_fulfillment_orders,write_assigned_fulfillment_orders,read_audit_events,read_customer_events,read_cart_transforms,write_cart_transforms,read_all_cart_transforms,read_validations,write_validations,read_cash_tracking,write_cash_tracking,read_channels,write_channels,read_checkout_branding_settings,write_checkout_branding_settings,write_checkouts,read_checkouts,read_companies,write_companies,read_custom_fulfillment_services,write_custom_fulfillment_services,read_custom_pixels,write_custom_pixels,read_customers,write_customers,read_customer_data_erasure,write_customer_data_erasure,read_customer_merge,write_customer_merge,read_delivery_customizations,write_delivery_customizations,read_price_rules,write_price_rules,read_discounts,write_discounts,read_discovery,write_discovery,write_draft_orders,read_draft_orders,read_files,write_files,read_fulfillment_constraint_rules,write_fulfillment_constraint_rules,read_fulfillments,write_fulfillments,read_gift_card_transactions,write_gift_card_transactions,read_gift_cards,write_gift_cards,write_inventory,read_inventory,write_inventory_shipments,read_inventory_shipments,write_inventory_shipments_received_items,read_inventory_shipments_received_items,write_inventory_transfers,read_inventory_transfers,read_legal_policies,write_legal_policies,read_delivery_option_generators,write_delivery_option_generators,read_locales,write_locales,write_locations,read_locations,read_marketing_integrated_campaigns,write_marketing_integrated_campaigns,write_marketing_events,read_marketing_events,read_markets,write_markets,read_markets_home,write_markets_home,read_merchant_managed_fulfillment_orders,write_merchant_managed_fulfillment_orders,read_metaobject_definitions,write_metaobject_definitions,read_metaobjects,write_metaobjects,read_online_store_navigation,write_online_store_navigation,read_online_store_pages,write_online_store_pages,write_order_edits,read_order_edits,read_orders,write_orders,write_packing_slip_templates,read_packing_slip_templates,read_payment_terms,write_payment_terms,read_payment_customizations,write_payment_customizations,read_privacy_settings,write_privacy_settings,read_product_feeds,write_product_feeds,read_product_listings,write_product_listings,read_products,write_products,read_publications,write_publications,read_purchase_options,write_purchase_options,write_reports,read_reports,read_resource_feedbacks,write_resource_feedbacks,read_returns,write_returns,read_script_tags,write_script_tags,read_shopify_payments_provider_accounts_sensitive,read_shipping,write_shipping,read_shopify_payments_accounts,read_shopify_payments_payouts,read_shopify_payments_bank_accounts,read_shopify_payments_disputes,write_shopify_payments_disputes,read_content,write_content,read_store_credit_account_transactions,write_store_credit_account_transactions,read_store_credit_accounts,write_theme_code,read_themes,write_themes,read_third_party_fulfillment_orders,write_third_party_fulfillment_orders,read_translations,write_translations,read_pixels,write_pixels,customer_read_companies,customer_write_companies,customer_write_customers,customer_read_customers,customer_read_draft_orders,customer_read_markets,customer_read_metaobjects,customer_read_orders,customer_write_orders,customer_read_store_credit_account_transactions,customer_read_store_credit_accounts,unauthenticated_write_bulk_operations,unauthenticated_read_bulk_operations,unauthenticated_read_bundles,unauthenticated_write_checkouts,unauthenticated_read_checkouts,unauthenticated_write_customers,unauthenticated_read_customers,unauthenticated_read_customer_tags,unauthenticated_read_metaobjects,unauthenticated_read_product_pickup_locations,unauthenticated_read_product_inventory,unauthenticated_read_product_listings,unauthenticated_read_product_tags,unauthenticated_read_selling_plans,unauthenticated_read_shop_pay_installments_pricing,unauthenticated_read_content'
    }
  },
  base: {
    html_insertion: {
      title: 'HTMLタグ管理設定用スクリプト',
      description: 'BASE管理画面のApps >「HTMLタグ管理」を利用して、カスタムタグにこちらのコードを貼り付けてください。',
      code: `<script>
    (function() {
        function getCookieValue(cookieName) {
            var name = cookieName + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for (var i = 0; i < cookieArray.length; i++) {
                var cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                    cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                    return cookie.substring(name.length);
                }
            }
            return null;
        }

        function overwriteCookie(cookieName, cookieValue, expirationDays) {
            var d = new Date();
            d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/;SameSite=Lax";
        }
        
        function saveToLocalStorage(key, value) {
            try {
                localStorage.setItem(key, value);
            } catch (e) {
                console.error('Error saving to localStorage', e);
            }
        }

        function getFromLocalStorage(key) {
            try {
                return localStorage.getItem(key);
            } catch (e) {
                console.error('Error reading from localStorage', e);
                return null;
            }
        }

        function getAffiliateIDFromURL() {
            var urlParams = new URLSearchParams(window.location.search);
            var affiId_url = urlParams.get('affi_id');
            return affiId_url ? affiId_url : null;
        }

        var affiId = getCookieValue("affi_id");
        var fuId = getCookieValue("fu_id");
        var affiId_url = getAffiliateIDFromURL();

        if (affiId_url !== null) {
            overwriteCookie("affi_id", affiId_url, 90);
            saveToLocalStorage("affi_id", affiId_url);
            affiId = affiId_url;
        }

        if (affiId !== null) {
            document.cookie = 'name="_tracking_consent=; max-age=0';
            console.log('Page view event triggered for affiliate tracking.');
            const data = {
                affi_id: affiId,
            };

            if (fuId !== null) {
                data.fu_id = fuId;
            }

            console.log('Sending data:', data);

            fetch("${successfeeUrl}/base/visit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            })
            .then(response => {
                console.log('Success:', response);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                console.log('Response data:', data);
                const fuidFromResponse = data.fu_id;
                if (fuidFromResponse && fuId === null) {
                    overwriteCookie("fu_id", fuidFromResponse, 90);
                    saveToLocalStorage("fu_id", fuidFromResponse);
                } else if (!fuidFromResponse) {
                    console.log('FUIDがレスポンスに含まれていません。');
            }
            })
            .catch(error => {
                console.error('Error:', error);
            });
        } else {
            console.log('アフィリエイトIDが存在しません。データは送信されませんでした。');
        }
    })();
    </script>      
`
    },
    analytics: {
      title: '広告効果測定タグ設定用スクリプト (購入完了ページ)',
      description:
        'BASE管理画面の「広告効果測定 App」を利用して、「その他 のタグを設定」欄にこちらのコードを貼り付けてください。',
      code: `<script>
  window.addEventListener('DOMContentLoaded', function () {
    console.log("DOMが読み込まれました");

    function getCookie(name) {
      const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    }

    const affiliateId = getCookie('affi_id') || null;
    console.log("affiliateId:", affiliateId);

    const currentDomain = window.location.hostname;
    console.log("currentDomain:", currentDomain);

    const payload = {
      affi_id: affiliateId,
      store_id: __CLIENT_ID__,
      order_id: '{%order_id%}',
      amount: '{%item_total%}',
      timestamp: new Date().toISOString(),
      domain: currentDomain,
    };
    console.log("送信するデータ:", payload);

    fetch('${customAppUrl}/base/order', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
    .then(response => {
      console.log('リクエスト成功:', response);
      return response.json();
    })
    .then(data => {
      console.log("レスポンスデータ:", data);
    })
    .catch(error => console.error('リクエストエラー:', error));
  });
</script>
`
    }
  },

  colorme: {
    html_insertion: {
      title: 'コンバージョンタグ用スクリプト',
      description:
        'カラーミーショップ管理画面の「設定」 >「コンバージョンタグ」> 「ヘッドタグ内設置」欄にこちらのコードを貼り付けてください。',
      code: `<script>
function executeOnCheckoutComplete() {
  console.log("&#9989; Main logic started on checkout complete page.");

  function getAffiIdFromCookie() {
    const match = document.cookie.match(/(?:^|; )affi_id=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  if (!window.Colorme || !window.Colorme.sale) {
    console.error("&#10060; colorme.sale object is missing when logic was triggered.");
    return;
  }

  const sale = window.Colorme.sale;
  const customer = window.Colorme.customer || {};
  const affiId = getAffiIdFromCookie();
  const order_id = String(sale.id);

  console.log("&#128269; colorme.sale:", sale);
  console.log("&#128269; affiId from cookie:", affiId);

  const payload = {
    affi_id: affiId,
    order_id: order_id,
    total_price: sale.total_price,
    order_date: new Date().toISOString(),
    store_id: __CLIENT_ID__,
    store_user_id: customer.id ? String(customer.id) : ""
  };

  console.log("&#128228; Payload to send:", payload);

  fetch("${customAppUrl}/colorme/order", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  })
  .then(res => {
    console.log("&#9989; Order sent, response status:", res.status);
    return res.text();
  })
  .then(body => {
    console.log("&#128196; Response body:", body);
  })
  .catch(err => {
    console.error("&#128293; Order send failed:", err);
  });
}


(function setupAffiIdCookie() {
  const urlParams = new URLSearchParams(window.location.search);
  const affiIdFromUrl = urlParams.get("affi_id");

  if (affiIdFromUrl) {
    const expires = new Date();
    expires.setDate(expires.getDate() + 30);
    document.cookie = \`affi_id=\${encodeURIComponent(affiIdFromUrl)}; path=/; expires=\${expires.toUTCString()}; SameSite=Lax; Secure\`;
    console.log("&#127850; affi_id cookie saved:", affiIdFromUrl);
  }
})();


let checkCount = 0;
const maxChecks = 25;

const checkInterval = setInterval(() => {
  checkCount++;
  if (window.Colorme && window.Colorme.page) {
    if (window.Colorme.page === "checkout-complete") {
      if (window.Colorme.sale) {
        clearInterval(checkInterval);
        executeOnCheckoutComplete();
      }
    } else {
      console.log("&#8505;&#65039; Not on checkout-complete page. Current page:", window.Colorme.page);
      clearInterval(checkInterval);
    }
  }

  if (checkCount >= maxChecks) {
    clearInterval(checkInterval);
    console.warn("&#9200; Timed out waiting for Colorme object.");
  }
}, 200);

</script>
`
    },
    analytics: {
      title: 'HTML欄編集用スクリプト',
      description:
        'カラーミーショップ管理画面の「ネットショップ」>「デザイン」>「デザインテンプレート」>「テンプレート編集」>「共通」>「HTML/CSS」>「HTML編集」欄の一番下にこちらのコードを貼り付けてください。',
      code: `<script>
    (function() {
        function getCookieValue(cookieName) {
            var name = cookieName + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for (var i = 0; i < cookieArray.length; i++) {
                var cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                    cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                    return cookie.substring(name.length);
                }
            }
            return null;
        }

        function overwriteCookie(cookieName, cookieValue, expirationDays) {
            var d = new Date();
            d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/;SameSite=Lax";
        }
        
        function saveToLocalStorage(key, value) {
            try {
                localStorage.setItem(key, value);
            } catch (e) {
                console.error('Error saving to localStorage', e);
            }
        }

        function getFromLocalStorage(key) {
            try {
                return localStorage.getItem(key);
            } catch (e) {
                console.error('Error reading from localStorage', e);
                return null;
            }
        }

        function getAffiliateIDFromURL() {
            var urlParams = new URLSearchParams(window.location.search);
            var affiId_url = urlParams.get('affi_id');
            return affiId_url ? affiId_url : null;
        }

        var affiId = getCookieValue("affi_id");
        var fuId = getCookieValue("fu_id");
        var affiId_url = getAffiliateIDFromURL();

        if (affiId_url !== null) {
            overwriteCookie("affi_id", affiId_url, 90);
            saveToLocalStorage("affi_id", affiId_url);
            affiId = affiId_url;
        }

        if (affiId !== null) {
            document.cookie = 'name="_tracking_consent=; max-age=0';
            console.log('Page view event triggered for affiliate tracking.');
            const data = {
                affi_id: affiId,
            };

            if (fuId !== null) {
                data.fu_id = fuId;
            }

            console.log('Sending data:', data);

            fetch("${successfeeUrl}/colorme/visit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            })
            .then(response => {
                console.log('Success:', response);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                console.log('Response data:', data);
                const fuidFromResponse = data.fu_id;
                if (fuidFromResponse && fuId === null) {
                    overwriteCookie("fu_id", fuidFromResponse, 90);
                    saveToLocalStorage("fu_id", fuidFromResponse);
                } else if (!fuidFromResponse) {
                    console.log('FUIDがレスポンスに含まれていません。');
            }
            })
            .catch(error => {
                console.error('Error:', error);
            });
        } else {
            console.log('アフィリエイトIDが存在しません。データは送信されませんでした。');
        }
    })();
    </script>      
`
    }
  },

  eccube: {
    // EC-CUBEはクーポンコード運用が標準のため、トラッキングスクリプトは不要
    // API連携設定のみTrackingCodePage.tsxで提供
  },

  futureshop: {
    visit: {
      title: '測定タグ設定（共通出力）用スクリプト',
      description:
        'futureshop管理画面の「設定」>「プロモーション管理」>「測定タグ一覧」>「測定タグを追加する」>「共通出力」タブ>「出力内容」欄にこちらのコードを貼り付けてください。出力設定は「<body>タグ内（</body>の前）に出力する」を選択してください。',
      code: `<script src="https://unpkg.com/psl@1.15.0/dist/psl.umd.cjs"></script>
<script>
// Ver 1.1.0 
(function() {
    function getRootDomain() {
        if (typeof psl !== 'undefined') {
            var root = psl.get(window.location.hostname);
            return root ? '.' + root : window.location.hostname;
        }
        
        var hostname = window.location.hostname;
        var parts = hostname.split('.');
        if (parts.length <= 2 || /^\\d+\\.\\d+\\.\\d+\\.\\d+$/.test(hostname)) {
            return hostname;
        }
        var lastTwo = parts.slice(-2).join('.');
        var jpSLDs = ['co.jp', 'or.jp', 'ne.jp', 'gr.jp', 'ac.jp', 'ed.jp', 'go.jp'];
        if (jpSLDs.indexOf(lastTwo) !== -1) {
            return '.' + parts.slice(-3).join('.');
        }
        return '.' + parts.slice(-2).join('.');
    }

    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    }
    function setCookie(name, value, days) {
        var d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        var domain = getRootDomain();
        document.cookie = name + "=" + encodeURIComponent(value) + ";path=/;domain=" + domain + ";expires=" + expires + ";SameSite=Lax";
    }
    function getStorage(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
    function setStorage(key, value) { try { localStorage.setItem(key, value); } catch (e) {} }

    function getParam(name) {
        var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href);
        return results ? decodeURIComponent(results[1].replace(/\\+/g, " ")) : null;
    }

    var affiIdFromUrl = getParam("affi_id");
    if (affiIdFromUrl) {
        setCookie("affi_id", affiIdFromUrl, 90);
        setStorage("affi_id", affiIdFromUrl);
    }

    var affiId = affiIdFromUrl || getCookie("affi_id") || getStorage("affi_id");
    var fuId = getCookie("fu_id") || getStorage("fu_id");

    if (affiId) {
        var data = { affi_id: affiId };
        if (fuId) data.fu_id = fuId;

        fetch("${successfeeUrl}/futureshop/visit", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        })
        .then(function(res) { return res.json(); })
        .then(function(resData) {
            if (resData.fu_id && !fuId) {
                setCookie("fu_id", resData.fu_id, 90);
                setStorage("fu_id", resData.fu_id);
            }
        })
        .catch(function(e) { console.error('Tracking error:', e); });
    }
})();
</script>`
    },
    conversion: {
      title: '測定タグ設定（注文完了ページ）用スクリプト',
      description:
        'futureshop管理画面の「設定」>「プロモーション管理」>「測定タグ一覧」>「測定タグを追加する」>「注文完了ページ」タブ>「出力内容」欄にこちらのコードを貼り付けてください。出力設定は「<body>タグ内（</body>の前）に出力する」を選択してください。',
      code: `<script>
// Ver 1.0.0
(function() {
    var orderIdTag = "{% analytics.order_no %}"; 
    var totalAmountTag = "{% analytics.purchase_price_with_options_including_tax %}"; 

    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    }
    function getStorage(key) {
        try { return localStorage.getItem(key); } catch (e) { return null; }
    }

    var affiId = getCookie("affi_id") || getStorage("affi_id");
    var fuId = getCookie("fu_id") || getStorage("fu_id");

    if (affiId && orderIdTag && orderIdTag.indexOf("{%") === -1) {
        
        var amountNum = parseInt(String(totalAmountTag).replace(/,/g, ''), 10);

        var payload = {
            store_id: __CLIENT_ID__,
            order_id: orderIdTag,
            amount: isNaN(amountNum) ? 0 : amountNum,
            affi_id: affiId,
            fu_id: fuId,
            timestamp: new Date().toISOString()
        };

        fetch('${customAppUrl}/futureshop/order', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
        .catch(function(e) { console.error('Tracking error:', e); });
    }
})();
</script>`
    }
  },

  shopserve: {
    visit: {
      title: 'アクセス集計タグ設定用スクリプト',
      description:
        'ショップサーブ管理画面の「集客・運用」>「外部アクセス解析ツール」>「アクセス集計タグ設定」>「アクセス集計タグの設定」欄にこちらのコードを貼り付けてください。',
      code: `<script src="https://unpkg.com/psl@1.15.0/dist/psl.umd.cjs"></script>
<script>
// Ver 1.2.0 
(function() {
    function getRootDomain() {
        if (typeof psl !== 'undefined') {
            var root = psl.get(window.location.hostname);
            return root ? '.' + root : window.location.hostname;
        }
        
        var hostname = window.location.hostname;
        var parts = hostname.split('.');
        if (parts.length <= 2 || /^\\d+\\.\\d+\\.\\d+\\.\\d+$/.test(hostname)) {
            return hostname;
        }
        var lastTwo = parts.slice(-2).join('.');
        var jpSLDs = ['co.jp', 'or.jp', 'ne.jp', 'gr.jp', 'ac.jp', 'ed.jp', 'go.jp'];
        if (jpSLDs.indexOf(lastTwo) !== -1) {
            return '.' + parts.slice(-3).join('.');
        }
        return '.' + parts.slice(-2).join('.');
    }

    function setCookie(name, value, days) {
        var d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        var domain = getRootDomain();
        document.cookie = name + "=" + encodeURIComponent(value) + ";path=/;domain=" + domain + ";expires=" + expires + ";SameSite=Lax";
    }

    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    }

    function saveToLocalStorage(key, value) {
        try { localStorage.setItem(key, value); } catch (e) {}
    }

    function getFromLocalStorage(key) {
        try { return localStorage.getItem(key); } catch (e) { return null; }
    }

    function getAffiliateIDFromURL() {
        var results = new RegExp('[?&]affi_id=([^&#]*)').exec(window.location.href);
        return results ? decodeURIComponent(results[1].replace(/\\+/g, " ")) : null;
    }

    var affiIdFromUrl = getAffiliateIDFromURL();
    
    if (affiIdFromUrl) {
        setCookie("affi_id", affiIdFromUrl, 90);
        saveToLocalStorage("affi_id", affiIdFromUrl);
    }

    var affiId = affiIdFromUrl || getCookie("affi_id") || getFromLocalStorage("affi_id");
    var fuId = getCookie("fu_id") || getFromLocalStorage("fu_id");

    if (affiId) {
        var data = {
            affi_id: affiId
        };
        if (fuId) {
            data.fu_id = fuId;
        }

        fetch("${successfeeUrl}/shopserve/visit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data),
        })
        .catch(function(err) {
            console.error('Tracking error:', err);
        });
    }
})();
</script>`
    },
    conversion: {
      title: 'リマーケティング設定（購入完了ページ）用スクリプト',
      description:
        'ショップサーブ管理画面の「集客・運用」>「PPC・アフィリエイト広告」>「コンバージョンタグ設定」>「アフィリエイトの設定」欄にこちらのコードを貼り付けてください。',
      code: `<script>
// Ver 1.0.0
(function() {
    var orderNumTag = "__ORD_NUM__";
    var totalAmountTag = "__ITM_TOTAL__"; 

    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    }
    function getStorage(key) {
        try { return localStorage.getItem(key); } catch (e) { return null; }
    }

    var affiId = getCookie("affi_id") || getStorage("affi_id");
    var fuId = getCookie("fu_id") || getStorage("fu_id");

    if (affiId && orderNumTag && orderNumTag.indexOf("__") === -1) {
        
        var amountNum = parseInt(String(totalAmountTag).replace(/,/g, ''), 10);

        var payload = {
            store_id: __CLIENT_ID__,
            order_id: orderNumTag,
            amount: isNaN(amountNum) ? 0 : amountNum,
            affi_id: affiId,
            fu_id: fuId,
            timestamp: new Date().toISOString()
        };

        fetch('${customAppUrl}/shopserve/order', {
            method: 'POST',
            mode: 'no-cors',
            headers: {
                'Content-Type': 'text/plain'
            },
            body: JSON.stringify(payload),
        })
        .catch(function(err) { console.error('Tracking error:', err); });
    }
})();
</script>`
    }
  },

  makeshop: {
    analytics_head: {
      title: 'アクセス解析用タグ（bodyタグ用）',
      description:
        'makeshop管理画面の「アクセス解析用のタグの設定」>「アクセス解析タグの入力（bodyタグ用）」に以下のスクリプトを貼り付けてください。',
      code: `<script src="https://unpkg.com/psl@1.15.0/dist/psl.umd.cjs"></script>
<script>
// Ver 1.1.0 
(function() {
  function getRootDomain() {
    if (typeof psl !== 'undefined') {
      var root = psl.get(window.location.hostname);
      return root ? '.' + root : window.location.hostname;
    }
    
    var hostname = window.location.hostname;
    var parts = hostname.split('.');
    if (parts.length <= 2 || /^\\d+\\.\\d+\\.\\d+\\.\\d+$/.test(hostname)) {
      return hostname;
    }
    var lastTwo = parts.slice(-2).join('.');
    var jpSLDs = ['co.jp', 'or.jp', 'ne.jp', 'gr.jp', 'ac.jp', 'ed.jp', 'go.jp'];
    if (jpSLDs.indexOf(lastTwo) !== -1) {
      return '.' + parts.slice(-3).join('.');
    }
    return '.' + parts.slice(-2).join('.');
  }

  function getCookieValue(cookieName) {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
      var cookie = cookieArray[i];
      while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length);
      }
    }
    return null;
  }

  function overwriteCookie(cookieName, cookieValue, expirationDays) {
    var d = new Date();
    d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    var rootDomain = getRootDomain();

    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/;domain=" + rootDomain + ";SameSite=Lax";
  }

  function getAffiliateIDFromURL() {
    var urlParams = new URLSearchParams(window.location.search);
    var affiId_url = urlParams.get('affi_id');
    return affiId_url ? affiId_url : null;
  }

  var affiId = getCookieValue("affi_id");
  var fuId = getCookieValue("fu_id");
  var affiId_url = getAffiliateIDFromURL();

  if (affiId_url !== null) {
    overwriteCookie("affi_id", affiId_url, 90);
    affiId = affiId_url;
  }

  if (affiId !== null) {
    const data = {
      affi_id: affiId,
      client_id: __CLIENT_ID__
    };

    if (fuId !== null) {
      data.fu_id = fuId;
    }

    fetch("${successfeeUrl}/makeshop/visit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
    .then(response => {
      console.log('Success:', response);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      const fuidFromResponse = data.fu_id;
      if (fuidFromResponse && fuId === null) {
        overwriteCookie("fu_id", fuidFromResponse, 90);
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }
})();
</script>`
    },
    conversion_tag: {
      title: 'コンバージョンタグ（注文完了画面用）',
      description:
        'makeshop管理画面の「コンバージョンタグの設定」で、出力画面を「注文完了画面」、出力箇所を「<body>直後」に設定し、開始部に以下のスクリプトを貼り付けてください。',
      code: `<script src="https://unpkg.com/psl@1.15.0/dist/psl.umd.cjs"></script>
<script>
// Ver 1.1.0 
window.addEventListener('DOMContentLoaded', function () {
  function getRootDomain() {
    if (typeof psl !== 'undefined') {
      var root = psl.get(window.location.hostname);
      return root ? '.' + root : window.location.hostname;
    }

    var hostname = window.location.hostname;
    var parts = hostname.split('.');
    if (parts.length <= 2 || /^\\d+\\.\\d+\\.\\d+\\.\\d+$/.test(hostname)) {
      return hostname;
    }
    var lastTwo = parts.slice(-2).join('.');
    var jpSLDs = ['co.jp', 'or.jp', 'ne.jp', 'gr.jp', 'ac.jp', 'ed.jp', 'go.jp'];
    if (jpSLDs.indexOf(lastTwo) !== -1) {
      return '.' + parts.slice(-3).join('.');
    }
    return '.' + parts.slice(-2).join('.');
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  const affiliateId = getCookie('affi_id') || null;
  const fuId = getCookie('fu_id') || null;
  const orderId = '[ORDER_NUM]';

  const payload = {
    order_id: orderId,
    store_id: __CLIENT_ID__
  };

  if (affiliateId) {
    payload.affi_id = affiliateId;
  }

  if (fuId) {
    payload.fu_id = fuId;
  }

  fetch('${customAppUrl}/makeshop/order', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
  })
  .catch(error => console.error('Error:', error));
});
</script>`
    }
  }
};
